































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import Paper from './components/Paper.vue'
import DownLoadBtn from './components/DownLoadBtn.vue'
import DownLoadModal from './components/DownLoadModal.vue'
import SyncModal from './components/SyncModal.vue'
import OrderList from './components/OrderList.vue'
import { throttle, debounce } from 'throttle-debounce'
import { audioCheck } from './model/api'
@Component({
  components: { MainTemplate, Paper, DownLoadBtn, DownLoadModal, OrderList, SyncModal },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      // 通过 `vm` 访问组件实例
      if (from && from.name) {
        console.log(from)
        vm.from = from
      }
    })
  }
})
export default class Preview extends Vue {
  public titleFixed = false
  public visible = false
  public syncVisible = false
  public disbaled = false
  public questions = []
  public classification = []
  public from = '/question'
  public syncBtnStatus = false
  public tikuUrl = ''
  public checkOk = false
  public hasAudio = false
  public isBottom = false

  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get origin() {
    // console.log(this.$route.meta)
    return this.$route.meta && this.$route.meta.origin
  }
  private get subjectId() {
    return this.$store.state.subject.value
  }
  private get usage() {
    if (this.origin == 'auto') {
      return 2
    } else {
      return 1
    }
  }

  public mounted() {
    let self = this
    this.titleFixed = false
    window.addEventListener('scroll', throttle(20, this.handleScroll), true)
  }
  public beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false)
  }
  /**
   * handleScroll
   */
  public handleScroll() {
    this.$nextTick(() => {
      try {
        let dom: any = document.getElementById('pride_tab_fixed')
        let app: any = document.getElementById('app')
        let offsetTop = dom.getBoundingClientRect().top
        let scrollTop = app.scrollTop
        let clientHeight = app.clientHeight
        let scrollHeight = app.scrollHeight

        this.titleFixed = offsetTop < 0
        if (scrollHeight > clientHeight && scrollTop + clientHeight === scrollHeight) {
          this.isBottom = true
          console.log('到底了')
        } else {
          this.isBottom = false
        }
      } catch (e) {
        console.log(e)
      }
    })
  }
  public async checkAudio() {
    try {
      let { data, success }: any = await audioCheck({
        subject_id: this.subjectId,
        usage: this.usage
      })
      if (success) {
        this.hasAudio = data.has_audio
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.visible = true
    }
  }
  public showModal() {
    if (!this.cartInfo) return
    if (!this.cartInfo.title) {
      this.$message.warning('还没有填写试卷名称哦')
      return
    }
    if (this.cartInfo && this.cartInfo.question_ids && this.cartInfo.question_ids.length) {
      this.checkAudio()
    }
  }
  public showAsyncModal() {
    if (!this.cartInfo) return
    if (!this.cartInfo.title) {
      this.$message.warning('还没有填写试卷名称哦')
      return
    }
    if (this.cartInfo && this.cartInfo.question_ids && this.cartInfo.question_ids.length) {
      this.syncVisible = true
    }
  }
  public onCancel() {
    this.visible = false
    this.syncVisible = false
  }
  public onFinish(val) {
    console.log(val)
    this.syncBtnStatus = val.finish
    this.tikuUrl = val.url || ''
  }
  public goTiku() {
    if (!this.tikuUrl) return
    window.open(this.tikuUrl)
  }
  // 离开页面前
}
